import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Editor } from '@monaco-editor/react';
import { useTranslation } from 'react-i18next';

interface QueryEditorProps {
  value: string;
  onChange: (value: string) => void;
  onMount?: () => void;
  height?: number | string; // Add height prop for flexibility
}

const QueryEditor: React.FC<QueryEditorProps> = ({ value, onChange, onMount, height }) => {
  const { t } = useTranslation();

  // Use provided height or flex layout
  const containerStyle = height ? { height, bgcolor: 'white' } : { flex: 1, minHeight: 0, bgcolor: 'white' };

  return (
    <Box sx={containerStyle}>
      <Editor
        height="100%"
        width="100%"
        defaultLanguage="sql"
        value={value}
        onChange={(val) => onChange(val || '')}
        onMount={onMount}
        theme="vs"
        loading={
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <CircularProgress size={32} sx={{ mb: 2 }} />
              <Typography variant="body2" color="text.secondary">
                {t('vaultilake.lakehouse.queries.loadingEditor')}
              </Typography>
            </Box>
          </Box>
        }
        options={{
          minimap: { enabled: false },
          fontSize: 13,
          fontFamily: "'Consolas', 'Courier New', monospace",
          lineNumbers: 'on',
          scrollBeyondLastLine: false,
          automaticLayout: true,
          wordWrap: 'off',
          tabSize: 4,
          insertSpaces: true,
          contextmenu: true,
          selectOnLineNumbers: true,
          renderLineHighlight: 'line',
          cursorBlinking: 'smooth',
          smoothScrolling: true,
          padding: { top: 8, bottom: 8 },
        }}
      />
    </Box>
  );
};

export default QueryEditor;
